<pgh-modal-window>
  <div modal-close>
    <button mat-icon-button class="close-button mat-icon-button" sf-aria-label="Global_Close_Window" matDialogClose>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div modal-title>
    <div class="upload-receipt-title"><adp-label [labelKey]="uploadPage.title"></adp-label></div>
  </div>
  <div modal-title>
    <div *ngIf="!selectedDevice.hasReceipt" class="upload-receipt-subtitle"><adp-label [labelKey]="uploadPage.subTitle"></adp-label>
    </div>
    <div *ngIf="selectedDevice.hasReceipt || isSuccess" class="upload-receipt-subtitle">
      <mat-icon style="height:unset;" svgIcon="checkmark-circle"></mat-icon>
      <adp-label [labelKey]="uploadPage.receiptUploadedMessage"></adp-label>
    </div>
    <div *ngIf="selectedDevice.hasReceipt || isSuccess">
      <a [download]="imageName" [href]="imageString" sf-aria-label="Global_DownloadReceipt_Aria_Label">
        <mat-icon *ngIf="showPdfIcon" svgIcon="streamline-icon-office-file-adobe" class="receipt-icon"></mat-icon>
        <img *ngIf="!showPdfIcon" [src]="imageString" class="receipt-image" />
      </a>
      <div class="receipt-image-download">
        <adp-label [labelKey]="uploadPage.downloadMessage"></adp-label>
      </div>
    </div>
  </div>
  <div modal-body class="mt-30 mb-30">
    <div *ngIf="isReceiptUploadEnabled && !selectedDevice.hasReceipt" class="upload-receipt-container">
      <div *ngIf="selectedDevice.hasReceipt !== true && !isSuccess" class="dropzone" fileDragDrop
        (filesChangeEmitter)="onFileChange($event)">
        <div class="text-wrapper">
          <div class="centered">
            <div class="upload-receipt-description"><adp-label [labelKey]="uploadPage.dragDropLabel"></adp-label></div>
            <div>
              <input type="file" name="file" id="file" [accept]="allowedFileTypeExtensions"
                (change)="onFileChange($event.target.files)">
              <label for="file">
                <span class="upload-button textLink">
                  <mat-icon svgIcon="upload"></mat-icon>
                  <adp-label [labelKey]="uploadPage.uploadButtonLabel"></adp-label>
                </span>
              </label>
            </div>
            <div class="upload-receipt-file-extensions">{{ allowedFileTypeNames }}</div>
          </div>
        </div>
      </div>
      <div class="upload-error" *ngIf="uploadError">
        {{uploadError}}
      </div>
      <div class="file-list" *ngIf="currentFile">
        <div class="file-progress">
          <div class="info">
            <div class="name">
              {{ currentFile?.name }}
            </div>
            <div class="percent-progress" *ngIf="isLoading">
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="currentFile && !isLoading" class="upload-receipt-confirm">
        <mat-checkbox [(ngModel)]="uploadConfirmed">
        <adp-label [labelKey]="uploadPage.uploadConfirmationMessage"></adp-label>
        </mat-checkbox>
      </div>
    </div>
  </div>
  <div modal-footer>
    <div class="row reverse-wrap">
      <div *ngIf="selectedDevice.hasReceipt" class="col-12">
        <button mat-stroked-button color="primary" (click)="onOkClicked()"><adp-label [labelKey]="uploadPage.viewRecieptOKButtonLabel"></adp-label></button>
      </div>
      <div *ngIf="!selectedDevice.hasReceipt" class="col-md-6">
        <button mat-stroked-button color="primary" class="border-0" (click)="onCancelClicked()">
          <adp-label [labelKey]="uploadPage.cancelButtonLabel"></adp-label>
        </button>
      </div>
      <div *ngIf="!selectedDevice.hasReceipt" class="col-md-6">
        <button mat-flat-button color="accent" (click)="onSaveClicked()" [disabled]="!uploadConfirmed">
          <adp-label [labelKey]="uploadPage.submitButtonLabel"></adp-label>
        </button>
      </div>
    </div>
  </div>
</pgh-modal-window>
